import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LinkTypeService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/linktypes`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<Boo.Objects.LinkType[]> {
    return this.http.get<Boo.Objects.LinkType[]>(this.baseUrl);
  }
}
